import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ErrorService, Error } from '@app/services/error.service';
import { toParams } from '@shared/utils/query-to-params';
import { BusinessCode, CustomerDetail, Mapping, Subscription } from '@data/models/accounting-sage.model';

export const ACCOUNTING_SAGE_SERVICE_API_ROOT = '/accounting/v1';

@Injectable()
export class AccountingSageService {

    private errors: Error[];

    constructor(private errorService: ErrorService, private http: HttpClient) {
        this.errors = this.errorService.accountingSageServiceErrors;
    }

    public getCustomerDetail(companyId: string, companySource: string): Observable<CustomerDetail> {
        const url = `${ACCOUNTING_SAGE_SERVICE_API_ROOT}/customer-detail/${companyId}?source=${companySource}`;
        return this.http.get<CustomerDetail>(url)
            .pipe(
                catchError(this.errorService.errorHandler<CustomerDetail>(this.errors, 'Récupération des données de la société', null))
            );
    }

    public getMapping(companyId: string): Observable<Mapping> {
        return this.http.get<Mapping>(`${ACCOUNTING_SAGE_SERVICE_API_ROOT}/mapping/${companyId}`)
            .pipe(
                catchError(this.errorService.errorHandler<Mapping>(this.errors, 'Récupération des données de mapping', null))
            );
    }

    public getBusinessCode(businessCode: string, source?: string): Observable<BusinessCode> {
        const sourceFilter = source ? `?source=${source}` : '';
        return this.http.get<BusinessCode>(`${ACCOUNTING_SAGE_SERVICE_API_ROOT}/business-codes/${businessCode}${sourceFilter}`)
            .pipe(
                catchError(this.errorService.errorHandler<BusinessCode>(this.errors, 'Récupération du code affaire sage', null))
            );
    }

    public findBusinessCodes(query: object): Observable<BusinessCode[]> {
        const params = toParams(query);
        return this.http.get<{ businessCodes: BusinessCode[] }>(`${ACCOUNTING_SAGE_SERVICE_API_ROOT}/business-codes`, { params })
            .pipe(
                map(res => res.businessCodes),
                catchError(this.errorService.errorHandler<BusinessCode[]>(this.errors, 'Récupération des codes affaires', []))
            );
    }

    public findSubscriptions(businessCode: string): Observable<Subscription[]> {
        return this.http.get<{ subscriptions: Subscription[] }>(`${ACCOUNTING_SAGE_SERVICE_API_ROOT}/subscriptions/${businessCode}`)
            .pipe(
                map(res => res.subscriptions),
                catchError(this.errorService.errorHandler<Subscription[]>(this.errors, 'Récupération des données inscriptions', []))
            );
    }

}
